import React from 'react';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useImg, useText } from 'hooks';
import { MOBILE, TABLET } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Article = () => {
  return (
    <ChangeableBackgroundSection
      id="article-wrapper-bg"
      defaultStyle={{ background: '#fff' }}
    >
      <ArticleContainer>
        <Wrapper>
          <AboutContributor>
            {useText('acticle__name', true)}
            {useText('acticle__work', true)}
            <hr />
          </AboutContributor>
          <ArticleSubtitle>{useText('article__subtitle_facts', true)}</ArticleSubtitle>
          <BlockFacts>
            <Fact>
              <VerticalLine />
              <span />
              <Item>{useText('article__facts_text1', true)}</Item>
            </Fact>
            <Fact>
              <VerticalLine />
              <span />
              <Item>{useText('article__facts_text2', true)}</Item>
            </Fact>
            <Fact>
              <VerticalLine1 />
              <span />
              <Item>{useText('article__facts_text3', true)}</Item>
            </Fact>
          </BlockFacts>
          <Image>
            {useImg('article_img.webp', 'article_img')}
            {useText('article__img_text', true)}
          </Image>
          <Block>
            <Item>{useText('article__facts_text4', true)}</Item>
            <Item>{useText('article__facts_text5', true)}</Item>
            <Item>{useText('article__facts_text6', true)}</Item>
            <Item>{useText('article__facts_text7', true)}</Item>
            <Item>{useText('article__facts_text8', true)}</Item>
            <Item>{useText('article__facts_text9', true)}</Item>
            <Item>{useText('article__facts_text10', true)}</Item>
          </Block>
          <ArticleTitle>{useText('article__title', true)}</ArticleTitle>
          <Image>
            {useImg('article_img_1.webp', 'article_img_1')}
            {useText('article__img_text_1', true)}
          </Image>
          <ArticleText>{useText('article__text', true)}</ArticleText>
          <ArticleTitle1>{useText('article__title_1', true)}</ArticleTitle1>
          <Block>
            <Item>{useText('article__quote_text1', true)}</Item>
            <Item>{useText('article__quote_text2', true)}</Item>
            <Item>{useText('article__quote_text3', true)}</Item>
            <Item>{useText('article__quote_text4', true)}</Item>
            <Item>{useText('article__quote_text5', true)}</Item>
          </Block>
          <Image>
            {useImg('article_img_2.webp', 'article_img_2')}
            {useText('article__img_text_2', true)}
          </Image>
        </Wrapper>
      </ArticleContainer>
    </ChangeableBackgroundSection>
  );
};

const ArticleContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  @media ${TABLET} {
    max-width: 1200px;
  }

  @media ${MOBILE} {
    flex-direction: column;
    max-width: 768px;
    padding: 0;
  }
`;

const Wrapper = styled.div`
  max-width: 800px;

  @media ${TABLET} {
    padding-right: 10px;
    padding-left: 20px;
    max-width: 700px;
  }

  @media ${MOBILE} {
    padding: 0 20px;
  }
`;

const AboutContributor = styled.div`
  h3 {
    margin: 0;
    font-weight: 700;
    color: #141414;
    font-size: 18px;
    line-height: 22px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  p {
    color: #545658;
    font-size: 13px;
    line-height: 16px;
    font-size: 400;
  }

  hr {
    margin: 0;
    width: 40px;
    height: 1px;
    background: #8a8c8e;
    margin-top: 16px;
  }
`;

const BlockFacts = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  span {
    min-width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #e60505;
    margin-right: 10px;
    margin-top: 8px;
  }
`;

const Fact = styled.div`
  display: flex;
`;

const VerticalLine = styled.div`
  height: auto;
  width: 2px;
  min-width: 2px;
  background-color: #e60505;
  position: relative;
  left: 5px;
  top: 8px;
`;

const VerticalLine1 = styled.div`
  height: auto;
  width: 2px;
  min-width: 2px;
  background-color: transparent;
  position: relative;
  left: 5px;
`;

const Item = styled.div`
  letter-spacing: 0.5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1d1d1d;
  padding-bottom: 10px;

  a {
    color: #e60505;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
  }
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ArticleTitle = styled.div`
  h2 {
    margin: 0;
    color: #141414;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    margin-block: 24px;
  }

  @media ${MOBILE} {
    h1 {
      font-size: 32px;
      line-height: 36px;

      span {
        top: 8px;
      }
    }
  }
`;
const ArticleTitle1 = styled.h2`
  margin: 0;
  color: #141414;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  margin-block: 24px;

  a {
    color: #e60505;
    text-transform: uppercase;
    cursor: pointer;
    text-decoration: none;
  }
`;

const ArticleSubtitle = styled.div`
  h2 {
    margin: 0;
    color: #141414;
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    margin-block: 24px;
  }
`;

const Image = styled.div`
  position: relative;
  margin-top: 24px;
  cursor: pointer;

  p {
    background: #e5e5e5;
    width: auto;
    display: block;
    margin-bottom: 1em;
    padding: 10px;
    font-size: 14px;
    color: #555;
    position: relative;
    top: -4px;
  }
`;

const ArticleText = styled.div`
  color: #1d1d1d;
  border-left: 5px solid #e60505;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding-left: 10px;
  margin-top: 8px;
`;

export default Article;
